import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const SavedIcon = (props) => {
  const { themeName, getThemeColor,getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5835 0.25H10.5835L13.5835 3.25V12.25C13.5835 13.075 12.9085 13.75 12.0835 13.75H1.5835C0.750996 13.75 0.0834961 13.075 0.0834961 12.25V1.75C0.0834961 0.925 0.750996 0.25 1.5835 0.25ZM12.0835 12.25V3.8725L9.961 1.75H1.5835V12.25H12.0835ZM6.8335 7C5.5885 7 4.5835 8.005 4.5835 9.25C4.5835 10.495 5.5885 11.5 6.8335 11.5C8.0785 11.5 9.0835 10.495 9.0835 9.25C9.0835 8.005 8.0785 7 6.8335 7ZM9.0835 2.5H2.3335V5.5H9.0835V2.5Z"
        // fill = {props.active ? "white" : "#bfbfbf"}
        //fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default SavedIcon;
